<div class="ec-pod-creator-wizard-container" xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="!setVerticalStepper; else verticalStepperTemplate">
        <mat-horizontal-stepper [disableRipple]="true" [linear]="true">
            <ng-template matStepperIcon="edit" let-index="index">
                {{ index + 1 }}
            </ng-template>
            <mat-step [stepControl]="step1Form">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Configure POD resource'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_1"></ng-container>
                    <button app-primary-button
                            matStepperNext
                            [disabled]="!step1Form.valid">
                        {{ 'Save and continue'|i18n }}
                        <app-icon class="right-icon" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step [stepControl]="step2Form" *ngIf="isStep2Enabled">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Configure production plant'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_2"></ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                        <button app-ghost-button
                                matStepperPrevious>
                            <app-icon name="fal-arrow-left"></app-icon>
                            {{ 'Back'|i18n }}
                        </button>

                        <button app-primary-button
                                matStepperNext
                                [disabled]="!step2Form.valid || step2Busy">
                            {{ 'Save and continue'|i18n }}
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step [stepControl]="step3Form">
                <ng-template matStepLabel class="title">
                    <span class="title">{{ 'Complete configuration'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_3"></ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                        <button app-ghost-button
                                matStepperPrevious>
                            <app-icon name="fal-arrow-left"></app-icon>
                            {{ 'Back'|i18n }}
                        </button>

                        <button app-primary-button
                                matStepperNext
                                (click)="sendRequest()"
                                [disabled]="!step3Form.valid">
                            {{ 'Save'|i18n }}
                        </button>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </ng-container>

    <ng-template #verticalStepperTemplate>
        <mat-vertical-stepper [disableRipple]="true" [linear]="true">
            <ng-template matStepperIcon="edit" let-index="index">
                {{ index + 1 }}
            </ng-template>
            <mat-step [stepControl]="step1Form">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Configure POD resource'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_1"></ng-container>
                    <button app-primary-button
                            matStepperNext
                            [disabled]="!step1Form.valid">
                        {{ 'Save and continue'|i18n }}
                        <app-icon class="right-icon" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step [stepControl]="step2Form" *ngIf="isStep2Enabled">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Configure production plant'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_2"></ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                        <button app-ghost-button
                                matStepperPrevious>
                            <app-icon name="fal-arrow-left"></app-icon>
                            {{ 'Back'|i18n }}
                        </button>

                        <button app-primary-button
                                matStepperNext
                                [disabled]="!step2Form.valid">
                            {{ 'Save and continue'|i18n }}
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step [stepControl]="step3Form">
                <ng-template matStepLabel class="title">
                    <span class="title">{{ 'Complete configuration'|i18n }}</span>
                </ng-template>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <ng-container *ngTemplateOutlet="stepContent_3"></ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                        <button app-ghost-button
                                matStepperPrevious>
                            <app-icon name="fal-arrow-left"></app-icon>
                            {{ 'Back'|i18n }}
                        </button>

                        <button app-primary-button
                                matStepperNext
                                (click)="sendRequest()"
                                [disabled]="!step3Form.valid">
                            {{ 'Save'|i18n }}
                        </button>
                    </div>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </ng-template>

    <ng-template #stepContent_1>
        <form [formGroup]="step1Form" fxLayout="column" class="w-100">
            <div fxLayout="column" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-15">
                    <span class="txt-h-24-7">{{ 'Configure POD resource'|i18n }}</span>
                </div>

                <div fxLayout="column" fxLayoutGap.gt-xs="30px" fxLayoutGap.xs="20px" class="container"
                     [ngClass.gt-xs]="'p-30'" [ngClass.xs]="'p-20'">
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'">{{ ('Name'|i18n) + ':*' }}
                        </div>
                        <div fxFlex.gt-xs="50" [ngClass.xs]="'w-100'" app-input-container>
                            <input class="input-font"
                                   app-input
                                   [maxLength]="ENTITY_NAME_MAX_LENGTH"
                                   placeholder="{{'Name'|i18n}}"
                                   formControlName="podName">
                            <div *ngIf="entityNameError(step1Form.controls.podName) === 'duplicate'" app-error>
                                {{ 'Resource {0} already exists'|i18n:step1Form.controls.podName.value.trim() }}
                            </div>
                            <div *ngIf="entityNameError(step1Form.controls.podName) === 'pattern'" app-error>
                                {{ 'Characters {0} are invalid'|i18n:nameForbiddenCharacters }}
                            </div>
                            <div *ngIf="!this.step1Form.controls.podName.pristine && entityNameError(step1Form.controls.podName) === 'invalid'"
                                 app-error>
                                {{ 'Invalid name'|i18n }}
                            </div>
                        </div>
                        <div fxFlex.gt-xs="20"></div>
                    </div>
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'">{{ 'Type'|i18n }}:
                        </div>
                        <div fxFlex.gt-xs="70" [ngClass.xs]="'w-100'">
                            <span>POD</span>
                        </div>
                    </div>
                </div>

                <div fxLayout="column" fxLayoutGap.gt-xs="30px" fxLayoutGap.xs="20px" class="container"
                     [ngClass.gt-xs]="'p-30'" [ngClass.xs]="'p-20'">
                    <!-- pod code -->
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'">{{ ('POD code'|i18n) + ':*' }}
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100"
                             [ngClass.xs]="['mb-10']">
                            <div class="w-100" app-input-container>
                                <input app-input
                                       [readOnly]="isUpdate"
                                       formControlName="podCode"
                                       [maxLength]="POD_MAX_CHARS">
                                <div *ngIf="podError(step1Form) === 'pod'" app-error>
                                    {{ 'Invalid POD'|i18n }}
                                </div>
                                <div *ngIf="podError(step1Form) === 'unique_pod'" app-error>
                                    {{ 'POD already existing'|i18n }}
                                </div>
                                <div *ngIf="podError(step1Form) === 'pod_profile'" app-error>
                                    {{ 'POD profile unspecified'|i18n }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start">
                                <app-icon name="fas-info-circle"
                                          [title]="('14 or 15 digit alphanumeric code'|i18n) + '\n' + ('Example: IT001E123456789'|i18n)">
                                </app-icon>
                            </div>
                        </div>
                        <div fxFlex.gt-xs="20"></div>
                    </div>
                    <!-- energy profile -->
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             class="text-end" [ngClass.xs]="'w-100'">{{ 'Energy profile'|i18n }}:*
                        </div>
                        <div fxFlex.gt-xs="100" [ngClass.xs]="'w-100'" app-input-container>
                            <mat-radio-group class="set-gap" formControlName="podEnergyProfile"
                                             fxLayout.gt-xs="row wrap" fxLayout.xs="column" fxLayoutGap.gt-xs="35px"
                                             fxLayoutGap.xs="15px" color="primary">
                                <mat-radio-button app-radio-button *ngFor="let ep of energyProfiles"
                                                  [value]="ep"
                                                  [disabled]="isMobileMember && ep === EnergyProfiles.PRODUCER || isThirdPartyProducer && ep !== EnergyProfiles.PRODUCER"
                                                  class="txt-p-16-4">
                                    {{ ep|i18n }}
                                    <app-icon *ngIf="isMobileMember && ep === EnergyProfiles.PRODUCER"
                                              class="ml-10 txt-p-16-4" name="fas-info-circle"
                                              [title]="'You cannot set the energy profile of this POD as a producer because of a member accessing the mobile app.'|i18n"></app-icon>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div *ngIf="member && isThirdPartyProducer" fxLayout.gt-xs="row" fxLayout.xs="column"
                         fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'"></div>
                        <div fxLayout="row" fxLayoutAlign="center center"
                             fxFlex.gt-xs="100" [ngClass.xs]="'w-100'" fxLayoutGap="20px" class="info-panel">
                            <app-icon name="fas-info-circle"></app-icon>
                            <div>{{ 'This POD belongs to a third-party producer. Its energy profile cannot be different from producer.'|i18n }}</div>
                        </div>
                    </div>
                    <!-- Utility type -->
                    <!-- mandatory only if energy profile !== PRODUCER -->
                    <div *ngIf="member" fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">

                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             class="text-end" [ngClass.xs]="'w-100'">
                            {{ ('Utility type'|i18n) + ':' + (step1Form.controls.podEnergyProfile.value !== EnergyProfiles.PRODUCER ? '*' : '') }}
                        </div>

                        <div fxFlex.gt-xs="100" [ngClass.xs]="'w-100'">
                            <mat-select app-small-select class="mr-12"
                                        [disabled]="step1Form.controls.podEnergyProfile.value === EnergyProfiles.PRODUCER"
                                        formControlName="podUtilityType" placeholder="{{'Type of utility'|i18n}}"
                                        fxFlex>
                                <mat-option *ngFor="let utilityType of getPodUtilityTypes(member.juridical_type, member.legal_form,
                                member.subject_type, member.entity_subtype)"
                                            [value]="utilityType">
                                    <div>{{ utilityType|genericPipe }}</div>
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <!-- voltage connection -->
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'">{{ 'Voltage connection'|i18n }}:*
                        </div>
                        <div fxFlex.gt-xs="100" [ngClass.xs]="'w-100'" app-input-container>
                            <mat-radio-group class="set-gap" formControlName="podVoltage" fxLayout.gt-xs="row wrap"
                                             fxLayout.xs="column" fxLayoutGap.gt-xs="35px" fxLayoutGap.xs="15px"
                                             color="primary">
                                <mat-radio-button app-radio-button *ngFor="let pv of POD_VOLTAGES"
                                                  name="podVoltage"
                                                  [value]="pv.value" class="txt-p-16-4">
                                    {{ pv.name|i18n }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <!-- phases -->
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             [ngClass.xs]="'w-100'">{{ 'Phases'|i18n }}:*
                        </div>
                        <div fxFlex.gt-xs="100" [ngClass.xs]="'w-100'" app-input-container>
                            <mat-radio-group class="set-gap" formControlName="podPhase" fxLayout.gt-xs="row wrap"
                                             fxLayout.xs="column" fxLayoutGap.gt-xs="35px" fxLayoutGap.xs="15px"
                                             color="primary">
                                <mat-radio-button app-radio-button *ngFor="let pp of POD_PHASES" [value]="pp.value">
                                    {{ pp.name|i18n }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <!-- contractual power -->
                    <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                         fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                             class="text-end" [ngClass.xs]="'w-100'">{{ 'Contractual power'|i18n }}:
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100"
                             [ngClass.xs]="['mb-10']">
                            <div class="w-100" app-input-container>
                                <mat-select app-small-select formControlName="contractualPower"
                                            placeholder="{{'Contractual power'|i18n}}">
                                    <mat-option *ngFor="let cp of contractualPowerValues" [value]="cp">
                                        <div>{{ cp.name }}</div>
                                    </mat-option>
                                </mat-select>
                                <div *ngIf="isControlOK(step1Form,'contractualPower')" app-error>
                                    {{ 'Invalid value'|i18n }}
                                </div>
                            </div>
                        </div>
                        <div fxFlex.gt-xs="20"></div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template #stepContent_2>
        <div fxLayout="column" fxLayoutGap="30px" class="w-100">
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-15">
                <span class="txt-h-24-7">{{ 'Configure system connected to \"{0}\"'|i18n:podName }}</span>
            </div>
            <div fxLayout="column" fxLayoutGap.gt-xs="30px" fxLayoutGap.xs="20px" [ngClass.gt-xs]="'p-30'"
                 [ngClass.xs]="'p-20'">
                <div *ngFor="let plantForm of plantsControls; let i = index" fxLayout="column"
                     fxLayoutAlign.gt-xs="start start" fxLayoutAlign.xs="start start" fxLayoutGap.xs="20px"
                     fxLayoutGap.gt-xs="40px" class="container p-30">
                    <div fxLayout="row" class="w-100" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                        <div class="txt-h-18-7" fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start"
                             [ngClass.xs]="'w-100'" [ngClass.gt-xs]="'w-30'">
                            {{ ('Plant {0}'|i18n:i + 1) }}
                        </div>

                        <ng-container *ngIf="plantsControls.length > 1">
                            <div fxLayout="row" fxLayoutAlign="end" [ngClass]="'w-50'">
                                <button app-small-ghost-button class="app-button-alert"
                                        (click)="onClickRemovePlant(i)">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </ng-container>
                    </div>
                    <form [formGroup]="plantForm" fxLayout="column" class="w-100" fxLayoutGap="20px">
                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 [ngClass.xs]="'w-100'">{{ ('Name'|i18n) + ':*' }}
                            </div>
                            <div fxFlex.gt-xs="50" [ngClass.xs]="'w-100'" app-input-container>
                                <input class="input-font"
                                       app-input
                                       [maxLength]="ENTITY_NAME_MAX_LENGTH"
                                       placeholder="{{'Name'|i18n}}"
                                       formControlName="plantName">
                                <div *ngIf="entityNameError(plantForm.controls.plantName) === 'duplicate'" app-error>
                                    {{ 'Resource {0} already exists'|i18n:plantForm.controls.plantName.value.trim() }}
                                </div>
                                <div *ngIf="entityNameError(plantForm.controls.plantName) === 'pattern'" app-error>
                                    {{ 'Characters {0} are invalid'|i18n:nameForbiddenCharacters }}
                                </div>
                                <div *ngIf="!plantForm.controls.plantName.pristine && entityNameError(plantForm.controls.plantName) === 'invalid'"
                                     app-error>
                                    {{ 'Invalid name'|i18n }}
                                </div>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 [ngClass.xs]="'w-100'">{{ ('Type'|i18n) + ':*' }}
                            </div>
                            <mat-select app-small-select formControlName="plantType"
                                        placeholder="{{'Type of plant'|i18n}}" fxFlex.gt-sm="43">
                                <mat-option *ngFor="let plant of PLANT_TYPES" [value]="plant">
                                    <div>{{ plant.name|i18n }}</div>
                                </mat-option>
                            </mat-select>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 [ngClass.xs]="'w-100'">{{ ('Production POD'|i18n) + (mandatoryProductionPod(plantForm) ? ':*' : ':') }}
                            </div>
                            <div fxLayout="row" fxLayoutGap="10px" [ngClass.xs]="'w-100'"
                                 fxLayoutAlign.gt-xs="start center"
                                 fxLayoutAlign.xs="start start" fxFlex.gt-xs="70">
                                <div app-input-container class="mi-w-65">
                                    <input app-input formControlName="podCode" [maxLength]="POD_MAX_CHARS">
                                    <div *ngIf="podError(plantForm) === 'pod'" app-error>
                                        {{ 'Invalid POD'|i18n }}
                                    </div>
                                    <div *ngIf="podError(plantForm) === 'unique_pod'" app-error>
                                        {{ 'POD already existing'|i18n }}
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start">
                                    <app-icon name="fas-info-circle"
                                              [title]="('14 or 15 digit alphanumeric code, example: ITP0AE123456789'|i18n)">
                                    </app-icon>
                                </div>
                            </div>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 [ngClass.xs]="'w-100'">{{ ('Nominal power'|i18n) + ':*' }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="m-w-15"
                                 [ngClass.xs]="['mb-10']">
                                <div app-input-container>
                                    <input app-input
                                           type="number"
                                           step="0.01"
                                           formControlName="nominalPower"
                                           (input)="limitDecimals(plantForm, 'nominalPower')">
                                    <div *ngIf="isControlOK(plantForm, 'nominalPower')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start">kW</div>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </div>

                        <div *ngIf="!(member && member.participation_type === ECMemberParticipationType.THIRD_PARTY_PRODUCER)"
                             fxLayout="column" fxLayoutGap="20px">
                            <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                                 fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                                <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                     [ngClass.xs]="'w-100'">
                                    {{ ('Capital grant'|i18n) + (plantForm.controls.capitalGrant.disabled ? ':' : ':*') }}
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="m-w-18"
                                     [ngClass.xs]="['mb-10']">
                                    <div app-input-container>
                                        <input app-input
                                               type="number"
                                               step="0.01"
                                               formControlName="capitalGrant"
                                               (input)="limitDecimals(plantForm, 'capitalGrant')"
                                               [disabled]="plantForm.controls.capitalGrant.disabled">
                                        <div *ngIf="isControlOK(plantForm, 'capitalGrant') && plantForm.controls.capitalGrant.enabled"
                                             app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start">%</div>
                                    <app-icon name="fas-info-circle"
                                              [title]="getFormControl(plantForm,'capitalGrant').enabled ?
                                                          ('Percentage of public funding given to the member or community for expenses incurred in the construction of a renewable plant, up to a maximum of 40%. Its use results in a reduction of the incentive fee by up to 50% in proportion to the percentage of contribution received.'|i18n) :
                                                          ('To configure capital grant the plant effective date must be same as or later than {0}'|i18n:(UPPER_INCENTIVE_BOUNDARY|i18nDate))">
                                    </app-icon>
                                </div>
                            </div>
                            <div *ngIf="getFormControl(plantForm,'capitalGrant').enabled"
                                 fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                                 fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                                <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                     [ngClass.xs]="'w-100'"></div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100 txt-s-12-7"
                                     [ngClass.xs]="['mb-10']">
                                    <div class="w-100">
                                        {{ 'From {0} to {1}'|i18n:0:40 }}%
                                    </div>
                                </div>
                                <div fxFlex.gt-xs="20"></div>
                            </div>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 [ngClass.xs]="'w-100'">{{ 'Effective date'|i18n }}:
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100"
                                 [ngClass.xs]="['mb-10']">

                                <div fxLayout="row" fxLayoutAlign="start center" app-input-container class="w-100"
                                     fxLayoutGap="10px">
                                    <ng-container *ngIf="hasDate(plantForm)">
                                        <div fxLayout="column">
                                            <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                                 fxLayoutGap="4px">
                                                <input app-input [matDatepicker]="effectiveDatePicker"
                                                       formControlName="enterData"
                                                       [disabled]="isUpdate ? hasDate(plantForm) : false">
                                                <mat-datepicker #effectiveDatePicker></mat-datepicker>
                                                <div *ngIf="getDateError(plantForm) === 'bad_date'" app-error>
                                                    {{ 'Invalid date'|i18n }}
                                                </div>
                                            </div>
                                        </div>
                                        <button app-ghost-button *ngIf="isUpdate ? canResetActivationDate(plantForm): true"
                                                (click)="onClickResetDate(plantForm)">
                                            <app-icon name="fal-calendar-alt"></app-icon>
                                            {{ 'Reset date'|i18n }}
                                        </button>
                                    </ng-container>
                                    <button *ngIf="!hasDate(plantForm)" app-ghost-button
                                            (click)="onClickSetDate(plantForm)">
                                        <app-icon name="fal-calendar-alt"></app-icon>
                                        {{ 'Insert date'|i18n }}
                                    </button>
                                </div>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxFlex.gt-xs="30" [ngClass.xs]="'w-100'"></div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100"
                                 [ngClass.xs]="['mb-10']">
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <app-icon name="fas-info-circle"></app-icon>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start start">
                                        <div>{{ 'Without this date, the economic input data will be incomplete.'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </div>

                        <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign.gt-xs="start center"
                             fxLayoutAlign.xs="start start" fxLayoutGap.xs="10px" fxLayoutGap.gt-xs="30px">
                            <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxLayoutAlign.xs="start" fxFlex.gt-xs="30"
                                 class="text-end" [ngClass.xs]="'w-100'">{{ 'Incentive mode'|i18n }}:
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="w-100"
                                 [ngClass.xs]="['mb-10']">
                                <div class="w-100" app-input-container *appVar="getIncentiveTypes(plantForm) as plantIncentiveTypes">
                                    <mat-select app-small-select formControlName="incentiveType"
                                                [disabled]="!hasDate(plantForm) || plantIncentiveTypes[1]"
                                                placeholder="{{'Incentive mode'|i18n}}">
                                        <mat-option *ngFor="let it of plantIncentiveTypes[0]" [value]="it">
                                            <div>{{ it|genericPipe|i18n }}</div>
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div fxFlex.gt-xs="20"></div>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center" class="w-100">
                            <app-wizard-pod-card formControlName="profile"
                                                 [mode]="WizardPodCardMode.STATISTICAL_PROFILE"
                                                 [resource]="mkStatisticalProfilePlantResource(plantForm)"
                                                 [resetValueProvider]="mkPlantStatisticalProfileResetValueProvider(plantForm)"
                                                 [isRequired]="plantForm.controls.plantType.value === WIND_PLANT_TYPE"
                                                 [ngClass.gt-xs]="'w-85'" [ngClass.xs]="'w-100'">
                            </app-wizard-pod-card>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center" class="w-100">
                            <app-wizard-pod-card formControlName="predictiveModel"
                                                 [mode]="WizardPodCardMode.PREDICTIVE_MODEL"
                                                 [resource]="mkPredictiveModelPlantResource(plantForm)"
                                                 [resetValueProvider]="mkPlantPredictiveModelResetValueProvider(plantForm)"
                                                 [ngClass.gt-xs]="'w-85'" [ngClass.xs]="'w-100'">
                            </app-wizard-pod-card>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center" *ngIf="i === plantsControls.length-1"
                             class="mt-20">
                            <button app-ghost-button
                                    class="fix-button"
                                    (click)="onClickCreatePlant()">
                                <app-icon name="fal-plus-square"></app-icon>
                                <span>{{ 'Add another plant'|i18n }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #stepContent_3>
        <form [formGroup]="step3Form" class="w-100">
            <div fxLayout="column" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-15">
                    <span class="txt-h-24-7">{{ 'Complete "{0}" configuration'|i18n:podName }}</span>
                </div>

                <div fxLayout="column" fxLayoutGap.gt-xs="30px" fxLayoutGap.xs="20px" class="container"
                     [ngClass.gt-xs]="'p-80'" [ngClass.xs]="'p-20'">
                    <app-wizard-pod-card *ngIf="podEnergyProfile !== EnergyProfiles.PRODUCER" class="'w-100'"
                                         formControlName="profile"
                                         [mode]="WizardPodCardMode.STATISTICAL_PROFILE"
                                         [resource]="mkStatisticalProfilePodResource()"
                                         [resetValueProvider]="mkPodStatisticalProfileResetValueProvider()"
                                         [isRequired]="true">
                    </app-wizard-pod-card>
                    <div *ngIf="podEnergyProfile === EnergyProfiles.PRODUCER" fxLayout="row"
                         fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <app-icon name="fas-info-circle"></app-icon>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div>{{ 'As a producer, the statistical profile of this POD is derived from that of its facilities'|i18n }}
                                .
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</div>

<ng-template #adviceDialog let-close="close">
    <div [style.width]="window.innerWidth*0.9+'px'" fxLayout="column" class="advice-dialog text-center"
         fxLayoutAlign="center center" fxLayoutGap="35px">
        <span class="txt-h-24-7">{{ 'Source of energy data for this POD'|i18n }}</span>
        <span class="txt-p-16-4" [ngClass.xs]="'w-100'" [ngClass.gt-xs]="'w-60'">
            {{ ('If a smart meter is connected to this exchange POD, the platform will show its monitored data. Otherwise, statistical data will be shown'|i18n) + '.' }}
        </span>
        <button app-primary-button (click)="close()" class="w-10">
            {{ 'Ok' }}
        </button>
    </div>
</ng-template>

<ng-template #adviceDialog2 let-close="close">
    <div [style.width]="window.innerWidth*0.9+'px'" fxLayout="column" class="advice-dialog text-center"
         fxLayoutAlign="center center" fxLayoutGap="35px">
        <!--        <span class="txt-h-24-7">{{ 'Are you sure to set "{0}" the consumer?'|i18n:podName }}</span>-->
        <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
            {{ 'Warning: the production resources of this POD will be deleted'|i18n }}
        </div>
        <span class="txt-p-16-4" [ngClass.xs]="'w-100'" [ngClass.gt-xs]="'w-60'">
            {{ 'By setting "{0}" as a consumer, your production plants will be eliminated'|i18n:podName }}.
        </span>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #setDate let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
        {{ 'Warning: you will not be able to modify the inserted date'|i18n }}
    </div>
    <div class="light-background">
        <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
            {{ 'Enter the date the system was connected to the grid'|i18n }}.
        </div>
        <app-activation-date
                [timeZone]="data.timeZone"
                [setDefaultDate]="true"
                (activationDate)="data.activationDate=$event"
        ></app-activation-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.activationDate" (click)="close(data.activationDate)">
            {{ 'Confirm date'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>
